import styled from "styled-components";
import { Button } from "../Button";
export const StyledBackwardButton = styled(Button) `
  padding-left: 0;
  justify-content: ${({ isIcon }) => (isIcon ? "center" : "flex-start;")}
    ${({ isAnchor, isIcon }) => !isIcon
    ? isAnchor
        ? "padding-right: 0.5rem;"
        : "padding-right: 1rem;"
    : "padding-right: 0;"}
    ${({ isIcon }) => isIcon
    ? "width: 3rem; height: 3rem;"
    : "min-height: 2.5rem; min-width: 3.75rem;"}
    span {
    display: flex;
    align-items: center;
    ${({ isIcon }) => (!isIcon ? "min-width: 2rem;width: 2rem;" : "")}
    ${({ isIcon }) => isIcon ? "min-width: 3rem;width: 3rem;height: 3rem;" : ""}

    svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
`;
